import Env from '../base/env';
import Channels from '../base/channels';
import Component from 'gia/Component';
import Accordion from 'accordion-js'
import gsap from 'gsap';
import { ScrollTrigger } from '../vendor/gsap-bonus-umd/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import easesCustom from '../fx/CustomEases';

export default class Module extends Component
{
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.texts = this.DOM.view.querySelectorAll('.fxText')

    //! Accordion
    this.accordionSpecs = new Accordion(this.ref.accordionInstance[0], {
      duration: 400,
      showMultiple: true,
      onClose: function(currentElement) {
        Channels.emit('accordion::update')
      },
      onOpen: function(currentElement) {
        Channels.emit('accordion::update')
      }
    });
    //? Fns
    setTimeout(() => {
      this._fx()
    }, 100);

  }

  _fx()
  {
    this.animate()
    this.reveal()
  }

  animate()
  {
    this.animation = gsap.timeline()

    this.animation
    .add([
      gsap.fromTo(
        this.DOM.texts,
        {
          autoAlpha:0,
          y:15,
        },
        {
          autoAlpha:1,
          y:0,
          ease:'quint.out',
          duration:.9,
          stagger:.2
        }
      ),
    ])
  }

  reveal()
  {
    const offsetStart = (Env.mobileCSS)?'top 85%':'top 65%';
    this.st = ScrollTrigger.create({
      animation:this.animation,
      trigger:this.DOM.view,
      start:offsetStart,
    })
  }

  unmount()
  {
    this.st.kill()
    this.accordionSpecs.destroy()
  }
}
